import Vue from 'vue'
import Cognito from './cognito'
import config from './../config'

var targetConf = process.env.NODE_ENV
var authType = process.env.VUE_APP_AUTH_TYPE || 'Cognito'
if (targetConf === undefined) {targetConf = 'test'}
Vue.use(Cognito, config[targetConf], authType)

export default new Cognito()
